import { gql } from 'glimmer-apollo';

export const GAMES_POST_QUERY = gql`
  query ($slug: String) {
    article: gameArticle(slug: $slug) {
      title
      slug
      shortDescription
      publishedDate
      body
      coverImage {
        url
      }
      author {
        name
        bio
        socialLinks {
          url
          platform
          accessibilityDescription
        }
        avatar {
          url
        }
      }
      relatedArticles {
        __typename
        title
        shortDescription
        slug
        publishedDate
        coverImage {
          url
        }
        author {
          name
          avatar {
            url
          }
        }
      }
    }
  }
`;
